var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from 'react';
import { LitNodeClient } from '@lit-protocol/lit-node-client';
import { LitAuthClient, } from '@lit-protocol/lit-auth-client';
import { ProviderType } from '@lit-protocol/constants';
export default function useLitClients(_a) {
    var redirectUri = _a.redirectUri;
    var _b = useState(process.env.NEXT_PUBLIC_LIT_NETWORK), litNetwork = _b[0], setLitNetwork = _b[1];
    var _c = useState(null), litAuthClients = _c[0], setLitAuthClients = _c[1];
    var _d = useState(null), litNodeClient = _d[0], setLitNodeClient = _d[1];
    var _e = useState(false), clientCreated = _e[0], setClientCreated = _e[1];
    var _f = useState(null), clientCreationError = _f[0], setClientCreationError = _f[1];
    var _g = useState(false), clientsLoading = _g[0], setClientsLoading = _g[1];
    function initClients() {
        return __awaiter(this, void 0, void 0, function () {
            var litNodeClient_1, authClientNames, authClients_1, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        setClientsLoading(true);
                        litNodeClient_1 = new LitNodeClient({
                            litNetwork: litNetwork,
                            debug: true,
                            litRelayConfig: {
                                relayApiKey: '15f362f6-a0cd-4f27-a02c-07311831389a_brihu',
                            },
                            rpcUrl: process.env.NEXT_PUBLIC_LIT_RPC_URL,
                        });
                        return [4 /*yield*/, litNodeClient_1.connect()];
                    case 1:
                        _a.sent();
                        setLitNodeClient(litNodeClient_1);
                        authClientNames = [
                            ProviderType.Google,
                            ProviderType.EthWallet,
                            ProviderType.Apple,
                        ];
                        authClients_1 = {};
                        authClientNames.map(function (name) {
                            var client = new LitAuthClient({
                                litRelayConfig: {
                                    relayApiKey: '15f362f6-a0cd-4f27-a02c-07311831389a_brihu',
                                },
                                litNodeClient: litNodeClient_1,
                                rpcUrl: process.env.NEXT_PUBLIC_LIT_RPC_URL,
                            });
                            var provider = client.initProvider(name);
                            if (name !== ProviderType.EthWallet) {
                                provider.redirectUri = redirectUri;
                            }
                            authClients_1[name] = { client: client, provider: provider };
                        });
                        setLitAuthClients(authClients_1);
                        setClientCreated(true);
                        return [3 /*break*/, 4];
                    case 2:
                        e_1 = _a.sent();
                        console.error('Error initializing Lit clients:', e_1);
                        setClientCreationError("Error initializing Lit clients: ".concat(e_1.message));
                        return [3 /*break*/, 4];
                    case 3:
                        setClientsLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () {
        setLitAuthClients(null);
        setLitNodeClient(null);
        initClients();
    }, [litNetwork]);
    return {
        litNetwork: litNetwork,
        setLitNetwork: setLitNetwork,
        clients: {
            litAuthClients: litAuthClients,
            litNodeClient: litNodeClient,
            clientCreated: clientCreated,
            clientCreationError: clientCreationError,
            clientsLoading: clientsLoading,
        },
    };
}
